import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  FETCH_RENTAL_LIST_REQUEST,
  FETCH_RENTAL_LIST_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';
import moment from 'moment-timezone';

const fetchRentalListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_RENTAL_LIST_REQUEST),
    debounceTime(500),
    switchMap(({ params }) => {
      const {
        filter,
        numberPer,
        startDate,
        endDate,
        startDeliveryDate,
        endDeliveryDate,
        query,
        deliveryType,
        deliveryTime,
        billingStatus,
        truckIds,
        salesperson,
        source,
        zone,
        status,
        pickedStatus,
        checkedInStatus,
        selectedDate,
        selectedDeliveryDate,
        customerId,
        companyId,
        eventTiming,
        sortField,
        sortDirection,
        page,
        includeDeliveryTickets,
        contactCategories,
        prioritize_sticky,
        multilocationAllLocations,
        departmentIds,
        pickListStatus,
        sortByEvent,
        eventToken,
      } = params;

      // allow multiple statuses if comma-separated
      const orderStatus = status.includes(',') ? status.split(',') : status;

      const timeZone = moment.tz.guess();

      return from(
        service.get(
          import.meta.env.VITE_API_DOMAIN + '/api/rentals/paginated',
          {
            per: numberPer,
            filter: filter,
            billing_status: billingStatus,
            truck_ids: truckIds,
            salesperson: salesperson,
            source: source,
            start_date: startDate,
            end_date: endDate,
            start_delivery_date: startDeliveryDate,
            end_delivery_date: endDeliveryDate,
            time_zone_offset: zone,
            time_zone: timeZone,
            department_ids: departmentIds,
            pick_list_status: pickListStatus,
            rental_status: orderStatus,
            picked_status: pickedStatus,
            checked_in_status: checkedInStatus,
            selectedDate: selectedDate,
            selectedDeliveryDate: selectedDeliveryDate,
            show_all: false,
            query: query,
            customer_id: customerId,
            company_id: companyId,
            event_timing: eventTiming,
            sort_field: sortField,
            sort_direction: sortDirection,
            delivery_type: deliveryType,
            include_delivery_tickets: includeDeliveryTickets,
            setting_icon: deliveryTime,
            contact_categories: contactCategories,
            sort_by_event: sortByEvent,
            event_token: eventToken,
            page,

            ...(prioritize_sticky && { prioritize_sticky: true }),
            ...(multilocationAllLocations && {
              multilocation_all_locations: true,
            }),
          }
        )
      ).pipe(
        map((response) => {
          const { rentals, meta } = response.data;
          const payload = { rentals };
          if (meta?.pagination) {
            payload.pagination = meta.pagination;
          }
          return {
            type: FETCH_RENTAL_LIST_SUCCESS,
            payload,
          };
        }),
        catchError((err) => {
          console.error('fetchRentalListEpic error', err);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default fetchRentalListEpic;
